import { Box, Checkbox, CircularProgress } from '@mui/material'

import { ActionContainer } from './styles'
import { StructureTreeItem, TreeV2Props } from './types'

export interface TreeItemLabelProps {
	actionComponent?: TreeV2Props['actionComponent'],
	iconComponent?: TreeV2Props['iconComponent']
	isCheckboxDisabled?: boolean,
	isChecked?: boolean,
	isExpanded: boolean,
	isIndeterminate?: boolean,
	isLoading: boolean,
	item: StructureTreeItem,
	onCheckChange?: (checked: boolean) => void,
	selectMode?: boolean
}

export const TreeItemLabel = ({
	item,
	iconComponent,
	actionComponent,
	isExpanded,
	isLoading,
	selectMode,
	isChecked,
	isIndeterminate,
	isCheckboxDisabled,
	onCheckChange,
}: TreeItemLabelProps) => (
	<Box data-testid={`tree-item-label-${item.type}-${item.label}`} sx={{ display: 'flex', alignItems: 'center', gap: 0.25, width: '100%' }}>
		{selectMode && (
			<Checkbox
				size="small"
				checked={isChecked}
				indeterminate={isIndeterminate}
				disabled={isCheckboxDisabled}
				onClick={(e) => e.stopPropagation()}
				onChange={(e) => onCheckChange?.(e.target.checked)}
				sx={{ p: 0, mr: 0.5 }}
				data-testid={`tree-item-checkbox-${item.type}-${item.label}`}
			/>
		)}
		{iconComponent && iconComponent(item, isExpanded)}
		<Box data-testid={`tree-item-text-${item.type}-${item.label}`} sx={{ whiteSpace: 'nowrap' }}>{item.label}</Box>
		{isLoading && <CircularProgress data-testid={`tree-item-loading-${item.type}-${item.label}`} size={14} />}
		{actionComponent && (
			<ActionContainer data-testid={`tree-item-actions-${item.type}-${item.label}`} onClick={(e) => e.stopPropagation()}>
				{actionComponent(item, isExpanded)}
			</ActionContainer>
		)}
	</Box>
)

